import Nav from "../../components/UI/Nav"
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Transition from "../../components/UI/Transition";
import ProjectFooter from "../../components/UI/Footer/ProjectFooter";
import { motion } from "framer-motion";

export default function QDS() {

    useEffect(() => {
        const scrollToTop = () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        };

        scrollToTop();
    }, []);

    return (
        <Transition>
            <div
                style={{
                    backgroundColor: '#fce8c6',
                }}
                className="main__container infj__mainContainer re-padding">
                <div className="menu__fix">
                    <Nav />
                </div>


                <div className="pictok__container">
                    <section className="infj__topContainer topContainer">

                        <video autoPlay loop muted>
                            <source src="/assets/projects/qds/intro.mp4" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </section>
                    <section className="pictok__mainContainer">
                        <div className="pictok__mainTitle">
                            <h2>Overview</h2>
                        </div>

                        <div className="pictok__mainContent infj__content">
                            <p>
                                I attended QDS Hacks 2024 with approximately 250 participants, where within 48 hours, my team developed Busy Bites—a mobile app that helps busy BCIT students find and reserve free, healthy, home-cooked meals near campus. We were invited to compete in the final round and proudly finished in the Top 8.
                            </p>
                            <p>
                                Within the first 24 hours, my de and I created an introduction video that helped our team advance to the final round. Using Adobe Illustrator and After Effects, we designed and animated every element from scratch, including the logo, thumbnails, and characters.
                            </p>
                            <Link className="qds__btn" to="https://www.youtube.com/watch?v=13WTNew_ag0/" target="_blank" rel="noopener noreferrer">
                                <button><p>
                                    <strong>Check out Demo Video ↗</strong></p></button>
                            </Link>
                        </div>
                    </section>
                    <section className="pictok__mainContainer">
                        <div className="pictok__mainTitle">
                            <h2>Busy Bites</h2>
                        </div>
                        <div className="pictok__mainContent infj__content">
                            <p>
                                The difference for me between game design and web design lies in the planning phase. In game design, the whole plan and required assets were generated at the beginning, with minor changes incorporated later. Twinery was used for this project to identify potential breakpoints before proceeding to the actual coding phase.
                            </p>
                            <div className="qds-image-row">
                                 <img src="/assets/projects/qds/apphome.png" alt="busy bites app home page" className="mb__plan" />
                            <img src="/assets/projects/qds/appmap.png" alt="busy bites app map page" className="mb__plan" />
                            </div>
                           
                            <Link className="qds__btn" to="https://busy-bites.vercel.app/" target="_blank" rel="noopener noreferrer">
                                <button><p>
                                    <strong>Check out App Demo ↗</strong></p></button>
                            </Link>
                        </div>
                        </section>
                    <section className="pictok__mainContainer">
                        <div className="pictok__mainTitle">
                            <h2>Illustration</h2>
                        </div>

                        <div className="pictok__mainContent">
                            <p>
                                Examples of illustrations and logos we created for apps within a limited timeframe.
                            </p>
                            <motion.div
                                whileInView={{ x: [-100, 0] }}
                                transition={{ duration: 0.25, delay: 0, type: 'spring', stiffness: '200', damping: '40' }}
                                className="qds__4">
                                <img src="/assets/projects/qds/asset-1.png" alt="qds illustration example 1" />
                                <img src="/assets/projects/qds/asset-2.png" alt="qds illustration example 2" />
                                <img src="/assets/projects/qds/asset-3.png" alt="qds illustration example 3" />
                                <img src="/assets/projects/qds/asset-4.png" alt="qds illustration example 4" />
                                
                            </motion.div>
                        </div>
                    </section>
                </div>

            </div>

            <ProjectFooter projectName="qds"/>
        </Transition>

    )
}